module.exports = __webpack_public_path__ + "img/cancel-white.a1af64aa.svg";